<script>
  import pluralize from 'pluralize'
  import api from '../api'

  export default {
    props: ['address'],

    computed: {
      count () {
        return pluralize('photo', this.address.photos_count, true)
      },

      thumb () {
        if (! this.address.cover_photo) return

        return process.env.MIX_CDN + '500x0/' + this.address.cover_photo.path
      }
    },

    methods: {
      edit() {
        this.$router.push(`/addresses/${this.address.id}/edit`)
      },

      view() {
        this.$router.push(`/addresses/${this.address.id}`)
      },

      bin() {
        swal({
          title: "Are you sure?",
          showCancelButton: true,
          closeOnConfirm: false
        },
          async () => {
            await api.apios.delete(`/api/addresses/${this.address.id}`)
            swal.close()
            this.$emit('refresh')
          });
      }
    }
  }
</script>
<style>

  .address-card {
    cursor: pointer;
  }

  .card .address-card-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-weight: normal;
  }

</style>
<template>
  <div class="card address-card" @click="view">
    <header class="card-header">
      <p class="card-header-title address-card-title">
        {{ address.name }}<br />
        <small>{{ address.client.email }}</small>
      </p>
      <a class="card-header-icon" @click.stop="edit">
        <i class="fa fa-pencil"></i>
      </a>
      <a class="card-header-icon" @click.stop="bin">
        <i class="fa fa-trash"></i>
      </a>
    </header>
    <div class="card-image">
      <figure class="image">
        <img :src="thumb" alt="Image">
      </figure>
    </div>
    <div class="card-content">
      <span class="icon is-small">
        <i class="fa fa-camera-retro" aria-hidden="true"></i>
      </span>
      {{ count }}
    </div>
  </div>
</template>